import { JSX } from 'react';
import {
    Box,
    Grid
} from "@mui/material";
import {
    List,
    Datagrid,
    ReferenceManyField,
    TextField,
    ReferenceField,
    EditButton,
    Pagination
} from 'react-admin';


export const CustomerAccountMiniContainer: () => JSX.Element = (): JSX.Element => {

    return (
        <Box sx={ {
            width: '100%',
        } } >
            <Grid container spacing={ 2 }>
                <Grid size={ 12 } >
                    <Box sx={ {
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between'
                    } }>
                        <h3>{ "Customer Mini Data" }</h3>
                        <Box>

                        </Box>
                    </Box>
                </Grid>
                <Grid size={ 6 } >
                    <h4>{ "Email Finders" }</h4>
                   <ReferenceManyField source="emailFinders"
                                       pagination={ <Pagination /> }
                                       reference="email_finders" target="id" label="EmailFinders">
                       <Datagrid bulkActionButtons={ false }>
                           <TextField source="id" />
                           <TextField source="name" />
                           <ReferenceField source="company" reference="companies" label="Company" />
                           <EditButton label="View" />
                       </Datagrid>
                   </ReferenceManyField>
               </Grid>

                <Grid size={ 6 } >
                    <h4>{ "Mystery Shoppers" }</h4>
                    <ReferenceManyField source="mysteryShoppers"
                                        pagination={ <Pagination /> }
                                        reference="mystery_shoppers" target="id" label="MysteryShoppers">
                        <Datagrid bulkActionButtons={ false }>
                            <TextField source="id" />
                            <TextField source="name" />
                            <ReferenceField source="company" reference="companies" label="Company" />
                            <EditButton label="View" />
                        </Datagrid>
                    </ReferenceManyField>
                </Grid>

                <Grid size={ 6 } >
                    <h4>{ "Compliance Sniffers" }</h4>
                    <ReferenceManyField source="complianceSniffers"
                                        pagination={ <Pagination /> }
                                        reference="compliance_sniffers" target="id" label="ComplianceSniffers">
                        <Datagrid bulkActionButtons={ false }>
                            <TextField source="id" />
                            <TextField source="name" />
                            <ReferenceField source="company" reference="companies" label="Company" />
                            <EditButton label="View" />
                        </Datagrid>
                    </ReferenceManyField>
                </Grid>
            </Grid>
        </Box>
    );
}
